import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, productManagementHomeRoute } from 'config/Api.Config';

import useProductTransferOwnershipDocument from './ProductTransferOwnershipDocument.Hooks';
import Card from 'assets/components/card/Card';
import Page from 'assets/components/page/Page';
import ThemeCardRow from 'assets/components/card/themes/Theme.Card.Row';
import Box from 'assets/components/box/Box';
import UploadDocumentTranslationButton from 'module/productManagement/components/translations/UploadDocumentTranslationButton';
import Icon from 'assets/components/icon/Icon';
import Theme from 'assets/themes/Theme.Common';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import { getLocales } from 'assets/locales/Locale';

enum Actions {
  ADD = 'add',
  DELETE = 'delete',
}
export type Verify = Utils.VerifyExtends<
  Module.ProductManagement.ProductTransferOwnershipDocument.Actions,
  Utils.ValueOf<typeof Actions>
>;
export const productTransferOwnershipDocumentIndexRoute =
  productManagementHomeRoute + '/productTransferOwnershipDocument/:id?';
export default function ProductTransferOwnershipDocumentIndex() {
  const productTransferOwnershipDocumentHook = useProductTransferOwnershipDocument();
  const { lang } = getLocales();

  if (!productTransferOwnershipDocumentHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <DataProvider
      data={productTransferOwnershipDocumentHook}
      render={({
        canView,
        isLoadingProductTransferOwnershipDocument,
        productTransferOwnershipDocument,
        translatedDocumentList,
        reloadTranslatedDocs,
      }) =>
        canView && (
          <Page
            class={ThemePageList}
            isLoading={isLoadingProductTransferOwnershipDocument}
            style={{
              pageHeader: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingBottom: 0,
                background: Theme.Color.primary,
                color: Theme.Color.primaryAlt,
                borderBottom: 'none',
              },
            }}
            header={
              <Box style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                <Card
                  class={ThemeCardRow}
                  style={{
                    cardMedia: {
                      color: Theme.Color.primary,
                      background: Theme.Color.primaryAlt,
                    },
                  }}
                  media={<Icon class="fas-file-contract" />}
                  info={lang.productTransferOwnershipDocuments}
                  title={productTransferOwnershipDocument?.displayInfo?.title}
                  subtitle={productTransferOwnershipDocument?.documentCategory}
                />
                {productTransferOwnershipDocument && (
                  <Box>
                    <UploadDocumentTranslationButton
                      documentId={productTransferOwnershipDocument.id}
                      documentType="ProductTransferOwnershipDocument"
                      translatedDocuments={translatedDocumentList}
                      onFinish={reloadTranslatedDocs}
                    />
                  </Box>
                )}
              </Box>
            }
            subHeader={<b style={{ marginRight: 'auto' }} children={lang.productTransferOwnershipDocuments} />}
          />
        )
      }
    />
  );
}
